<template>
  <div class="search-table-pagination">
    <el-select
      ref="customPageSelectRef"
      v-model="selectedPageSize"
      class="custom-page-size"
      default-first-option
      allow-create
      popper-class="custom-page-size-select"
      @change="sizeChangeHandle"
    >
      <el-option
        v-for="size of pageSizes"
        :key="size"
        :value="size"
        :label="`${size}条/页`"
      />
      <el-option :disabled="true" :value="pageSize" :label="`${pageSize}条/页`">
        <el-input-number
          v-model="customInputSize"
          :min="1"
          :max="Math.max(...pageSizes) || 3000"
          class="custom-page-size-input"
          placeholder="分页大小"
          step-strictly
          :controls="false"
          @keydown.enter="customSizeChangeHandle"
        />
        <el-button
          class="custom-page-size-button"
          type="primary"
          @click="customSizeChangeHandle"
        >
          确定
        </el-button>
      </el-option>
    </el-select>
    <div class="total">共 {{ total }} 条</div>
    <div class="current-page">
      <el-button :disabled="currentPage <= 1" @click="pageChangeHandle(-1)">
        <el-icon><ArrowLeft /></el-icon>
      </el-button>
      <span>
        {{ total > 0 ? `${currentPage} / ${getTotalPage()}` : '' }}
      </span>
      <el-button
        :disabled="currentPage >= getTotalPage()"
        @click="pageChangeHandle(1)"
      >
        <el-icon><ArrowRight /></el-icon>
      </el-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue';

const props = defineProps<{
  pageSizes: number[];
  total: number;
  pageSize: number;
  currentPage: number;
}>();

const emit = defineEmits([
  'size-change',
  'current-change',
  'update:page-size',
  'update:current-page'
]);

const customInputSize = ref<number>();
const selectedPageSize = ref<number>(props.pageSize);
const customPageSelectRef = ref();

const setCustomPageSizeValue = () => {
  const { pageSizes, pageSize } = props;
  if (!pageSizes.includes(pageSize)) {
    customInputSize.value = pageSize;
  }
};

setCustomPageSizeValue();

watch(
  () => props.pageSize,
  () => {
    selectedPageSize.value = props.pageSize;
    setCustomPageSizeValue();
  }
);

const sizeChangeHandle = (v: string | number) => {
  emit('update:page-size', v);
  emit('update:current-page', 1);
  emit('size-change');
};

const getTotalPage = () => {
  return Math.ceil(props.total / props.pageSize);
};

const customSizeChangeHandle = () => {
  const value = customInputSize.value;
  if (value) {
    customPageSelectRef.value?.blur();
    sizeChangeHandle(value);
  }
};

const pageChangeHandle = (step: -1 | 1) => {
  const newPage = props.currentPage + step;
  if (newPage < 1 || newPage > getTotalPage()) {
    return false;
  }
  emit('update:current-page', newPage);
  emit('current-change');
};
</script>

<style lang="scss" scoped>
.search-table-pagination {
  display: flex;
  align-items: center;
  .current-page {
    display: flex;
    align-items: center;
  }
}
.custom-page-size {
  width: 128px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  margin-right: var(--el-pagination-item-gap, 16px);
}
.custom-page-size:hover {
  border: 1px solid #297ce6;
}
.custom-page-size-input,
.custom-page-size-button {
  height: 30px;
}
.custom-page-size-button {
  font-size: 12px;
  padding: 0 5px;
}
.custom-page-size-input {
  width: 63px;
  margin-right: 5px;
  :deep(.el-input__wrapper) {
    padding-left: 5px;
    padding-right: 0;
  }
  :deep(input) {
    text-align: left !important;
    &::placeholder {
      font-size: 12px;
    }
  }
}
.custom-page-size-select {
  color: red;
  .el-select-dropdown__item {
    padding: 0 20px !important;
  }
}
</style>
